// routes
import { PATH_SETTINGS } from "../../../routes/paths";
import { getIcon } from "./NavIcon";

const ICONS = {
  support: getIcon("support"),
  settings: getIcon("settings"),
};

const footerNavConfig = [
  {
    subheader: "settings",
    items: [
      {
        title: "Support",
        path: "https://www.trendrocket.io/product-faq",
        icon: ICONS.support,
      },
      {
        title: "Settings",
        path: PATH_SETTINGS.general,
        icon: ICONS.settings,
      },
    ],
  },
];

export default footerNavConfig;
